import createIcon from '../../createIcon';

/**
 * @component @name Girl
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNy41QzEyLjk3IDcuNSAxMy43NSA2LjcyIDEzLjc1IDUuNzVDMTMuNzUgNC43OCAxMi45NyA0IDEyIDRDMTEuMDMgNCAxMC4yNSA0Ljc4IDEwLjI1IDUuNzVDMTAuMjUgNi43MiAxMS4wMyA3LjUgMTIgNy41Wk0xNCAxNlYyMEgxMFYxNkg4TDEwLjM4IDkuNjJDMTAuNjMgOC45NSAxMS4yOCA4LjUgMTIgOC41QzEyLjcyIDguNSAxMy4zNyA4Ljk1IDEzLjYyIDkuNjJMMTYgMTZIMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Girl = createIcon('Girl', [
  [
    'path',
    {
      d: 'M12 7.5C12.97 7.5 13.75 6.72 13.75 5.75C13.75 4.78 12.97 4 12 4C11.03 4 10.25 4.78 10.25 5.75C10.25 6.72 11.03 7.5 12 7.5ZM14 16V20H10V16H8L10.38 9.62C10.63 8.95 11.28 8.5 12 8.5C12.72 8.5 13.37 8.95 13.62 9.62L16 16H14Z',
      key: '1g4qeh',
    },
  ],
]);

export default Girl;
